const animationMediaRevealEffect = () => {
	const items = gsap.utils.toArray('.wp-block-media-text');

	items.forEach((item) => {
		let q = gsap.utils.selector(item);
		let x;

		if (item.classList.contains('has-media-on-the-right')) {
			x = +50;
		} else {
			x = -50;
		}

		gsap.set(item, {
			opacity: 0,
		});
		gsap.set(q('figure'), {
			x: x,
			opacity: 0,
			scale: 0.95,
		});
		gsap.set(q('.wp-block-group > *'), {
			y: 50,
			opacity: 0,
		});

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: item,
				start: 'top bottom',
				//markers: true,
			},
		});

		tl.to(item, {
			opacity: 1,
			duration: 0.5,
			ease: 'power2.out',
		})
			.to(q('figure'), {
				x: 0,
				scale: 1,
				opacity: 1,
				duration: 0.75,
				ease: 'power2.out',
			})
			.to(
				q('.wp-block-group > *'),
				{
					opacity: 1,
					y: 0,
					duration: 0.5,
					ease: 'power2.out',
					stagger: 0.25,
				},
				'<25%'
			);
	});
};

export default animationMediaRevealEffect;
